import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_ASSEMBLY_LINE_LOAD_DATA } from 'api/actionTypes';

export default async function loadAssemblyLineDataAction(
  { state, apiClient },
  { householdListingId, reload },
) {
  typeCheck('householdListingId::PositiveNumber', householdListingId);

  const statePath = ['assemblyLine', 'byHouseholdListings', householdListingId];
  if (!reload && state.get(statePath)) {
    return state.get(statePath);
  }
  const assemblyLineData = await apiClient.postWithState({
    action: SR_API_ACTION_ASSEMBLY_LINE_LOAD_DATA,
    state: state,
    payload: {
      householdListingId,
    },
    onSuccess(assemblyLineData) {
      state.set(statePath, assemblyLineData);
    },
  });

  return assemblyLineData;
}
